export const sortOptions = new Map([
	['date-descending', 'DATE_NEWEST'],
	['date-ascending', 'DATE_OLDEST'],
	['stars-descending', 'RATING_HIGHEST'],
	['stars-ascending', 'RATING_LOWEST']
]);

const dateTransform = (dateString) => new Date(dateString);

const numberTransform = (numString) => parseInt(numString, 10);

const valuesAreEqual = (a, b, transform, attribute) =>
	transform(a.review._attributes[attribute]) ===
	transform(b.review._attributes[attribute]);

const descSort = (a, b, transform, attribute) =>
	transform(b.review._attributes[attribute]) -
	transform(a.review._attributes[attribute]);

const ascSort = (a, b, transform, attribute) =>
	transform(a.review._attributes[attribute]) -
	transform(b.review._attributes[attribute]);

export const createSort = (sortType) => {
	const [category, sortDirection] = sortType.split('-');

	if (category === 'date') {
		return sortDirection === 'descending'
			? (a, b) => descSort(a, b, dateTransform, 'date')
			: (a, b) => ascSort(a, b, dateTransform, 'date');
	} else if (category === 'stars') {
		// When multiple reviews have the same star rating, sort those by newest first because that is the default sort.
		if (sortDirection === 'descending') {
			return (a, b) =>
				valuesAreEqual(a, b, numberTransform, 'stars')
					? descSort(a, b, dateTransform, 'date')
					: descSort(a, b, numberTransform, 'stars');
		} else {
			return (a, b) =>
				valuesAreEqual(a, b, numberTransform, 'stars')
					? descSort(a, b, dateTransform, 'date')
					: ascSort(a, b, numberTransform, 'stars');
		}
	} else {
		// If for some reason the category comes in wrong, just sort by newest first, which is the default.
		return (a, b) => descSort(a, b, dateTransform, 'date');
	}
};

export const sortReviews = (reviews, sortFunction) =>
	reviews.sort(sortFunction);
